import confetti from "canvas-confetti";
import { haptic } from "./haptics";

const GOLD = ["#FFC107", "#FFE082", "#F59E0B", "#FDE68A", "#ffffff"];
const coin = (() => { try { return confetti.shapeFromText ? confetti.shapeFromText({ text: "🪙", scalar: 2 }) : null; } catch { return null; } })();

export function isBigWin(payout, stake) {
  return payout >= 500 || (stake > 0 && payout >= stake * 5);
}

/** Confetti burst + coin shower. Big wins get a longer multi-burst celebration. */
export function celebrateWin(payout, stake = 0) {
  const big = isBigWin(payout, stake);
  (big ? haptic.bigWin : haptic.win)();
  confetti({ particleCount: big ? 160 : 90, spread: big ? 110 : 75, origin: { y: 0.55 }, colors: [...GOLD, "#2563EB", "#10B981"] });
  const shower = (x) => confetti({ particleCount: big ? 14 : 8, angle: 90, spread: 40, startVelocity: 25, gravity: 1.1, ticks: 220, scalar: coin ? 2 : 1.4, origin: { x, y: -0.1 }, shapes: coin ? [coin] : ["circle"], colors: GOLD });
  let n = 0;
  const t = setInterval(() => { shower(0.2 + Math.random() * 0.6); if (++n >= (big ? 14 : 6)) clearInterval(t); }, 140);
  if (big) {
    setTimeout(() => confetti({ particleCount: 120, angle: 60, spread: 60, origin: { x: 0, y: 0.7 }, colors: GOLD }), 500);
    setTimeout(() => confetti({ particleCount: 120, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, colors: GOLD }), 700);
  }
}
